import { RBAC_PRODUCT_AREAS } from 'common/constants/rbacProductAreas';

export const dashboardOverview = {
  label: 'Dashboard',
  url: '/qa/reports/overview',
  key: 'qa-reports-overview-dashboard',
  icon: null,
};
export const interactions = {
  label: 'Interactions',
  url: '/qa/interactions',
  key: 'qa-interactions',
  icon: null,
};
export const calibrations = {
  label: 'Calibrations',
  url: '/qa/calibrations',
  key: 'qa-calibrations',
  icon: null,
};
export const assignments = {
  label: 'Assignments',
  url: '/qa/assignments',
  key: 'qa-assignments',
  icon: null,
};
export const reviewers = {
  label: 'Reviewers',
  url: '/qa/reviewers',
  key: 'qa-reviewers',
  icon: null,
};
export const dashboardReviews = {
  label: 'Dashboard',
  url: '/qa/reports/reviews',
  key: 'qa-reports-reviews',
  icon: null,
};
export const newReview = {
  label: 'New Review',
  url: '/qa/reviews/new',
  key: 'qa-new-review',
  icon: 'plus-circle',
};
export const agentTrends = {
  label: 'Trends',
  url: `/trends/team_member?product_area=${RBAC_PRODUCT_AREAS.FEEDBACK}`,
  key: 'agent-trends',
  icon: null,
};
export const team = {
  label: 'Team',
  url: `/trends/team?product_area=${RBAC_PRODUCT_AREAS.FEEDBACK}`,
  key: 'trends-team-dashboard',
  icon: null,
};
export const teamMember = {
  label: 'Team Member',
  url: `/trends/team_member?product_area=${RBAC_PRODUCT_AREAS.FEEDBACK}`,
  key: 'agent-trends',
  icon: null,
};
export const serviceRecovery = {
  label: 'Service Recovery',
  url: '/trends/service_recovery',
  key: 'trends-service-recovery-dashboard',
  icon: null,
};
export const company = {
  label: 'Company',
  url: '/trends/company',
  key: 'trends-company-dashboard',
  icon: null,
};
export const linkedAccounts = {
  label: 'Linked Accounts',
  url: '/trends/company/multi',
  key: 'trends-company-multi-dashboard',
  icon: null,
};
export const companyProgram = {
  label: 'Company Program',
  url: '/trends/company/program',
  key: 'trends-company-program-dashboard',
  icon: null,
};
export const tags = {
  label: 'Tags',
  url: '/trends/company/tags',
  key: 'trends-company-tags-reports',
  icon: null,
};
export const teams = {
  label: 'Teams',
  url: '/trends/company/teams',
  key: 'trends-company-teams-reports',
  icon: null,
};
export const teamMembers = {
  label: 'Team Members',
  url: '/trends/company/team_members',
  key: 'trends-company-team-members-reports',
  icon: null,
};
export const reportingGroups = {
  label: 'Groups',
  url: '/trends/company/reporting_groups',
  key: 'trends-company-reporting-groups-reports',
  icon: null,
};
export const unfulfilledRewards = {
  label: 'Unfulfilled Rewards',
  url: '/rewards_report',
  key: 'unfulfilled-rewards',
  icon: null,
};
export const rewardsLog = {
  label: 'Rewards Log',
  url: '/activity_log',
  key: 'rewards-log',
  icon: null,
};
export const votes = {
  label: 'Votes',
  url: '/rewards_votes',
  key: 'votes',
  icon: null,
};
export const streamStellaAdmin = {
  label: 'Stream',
  url: '/admin/company/view',
  key: 'admin-company-view-dashboard',
  icon: null,
};
export const stream = {
  label: 'Stream',
  url: '/',
  key: 'view-stream',
  icon: null,
};
export const trendsMenu = {
  label: 'Trends',
  url: '/trends',
  key: 'trends',
  icon: null,
  type: 'nested',
};
export const leaderboard = {
  label: 'Leaderboards',
  url: '/leaderboard',
  key: 'leaderboard-dashboard',
  icon: null,
};
export const qaMenu = {
  label: 'QA',
  url: '/qa',
  key: 'qa',
  icon: null,
  type: 'nested',
};
export const oneOnOnes = {
  label: '1:1s',
  url: '/one_on_ones',
  key: 'one_on_ones-1:1s',
  icon: null,
};
export const teamMemberOneOnOnes = {
  label: '1:1s',
  url: '/one_on_ones',
  getUrl: (id: number): string => `/one_on_ones?employee_id=${id}`,
  key: 'team_member_1:1s',
  icon: null,
};
export const performanceLink = {
  label: 'Performance',
  url: '/performance',
  key: 'performance-dashboard',
  icon: null,
};
export const performanceEmployeeLink = employeeId => ({
  label: 'Performance',
  url: `/performance?employeeId=${employeeId}`,
  key: 'performance-dashboard',
  icon: null,
});
export const performanceTeamLink = teamId => ({
  label: 'Performance',
  url: `/performance?teamId=${teamId}`,
  key: 'performance-dashboard',
  icon: null,
});
export const rewardsReportsMenu = {
  label: 'Rewards Reports',
  url: '/rewards',
  key: 'rewards-reports',
  icon: null,
  type: 'nested',
};
export const rewardsReport = {
  label: 'Rewards Report',
  url: '/rewards_votes',
  key: 'rewards-report',
  icon: null,
};

export const trendsDashboardsSectionLinks = {
  team,
  teamMember,
  serviceRecovery,
  company,
  linkedAccounts,
  companyProgram,
};

export const trendsReportsSectionLinks = {
  tags,
  teams,
  teamMembers,
  reportingGroups,
};

export const trendsLinks = {
  DashboardsSectionLinks: trendsDashboardsSectionLinks,
  ReportsSectionLinks: trendsReportsSectionLinks,
  agentTrends,
  trendsMenu,
};

export const rewardsReportsLinks = {
  rewardsVotes: rewardsReport,
  rewardsReportsMenu,
  unfulfilledRewards,
  rewardsLog,
  votes,
};

export const streamLinks = {
  streamStellaAdmin,
  streamStellaNonAdmin: stream,
};

export const qaLinks = {
  dashboardOverview,
  interactions,
  calibrations,
  assignments,
  reviewers,
  dashboardReviews,
  newReview,
  qaMenu,
};

export const qaPermissionNames = [
  {
    ...dashboardOverview,
    permissionName: 'viewQADashboard',
  },
  {
    ...calibrations,
    permissionName: 'manageCalibrations',
  },
  {
    ...assignments,
    permissionName: 'viewAssignments',
  },
  {
    ...reviewers,
    permissionName: 'viewReviewers',
  },
  {
    ...interactions,
    permissionName: 'reviewQA',
  },
  {
    ...newReview,
    permissionName: 'reviewQA',
  },
];
